// extracted by mini-css-extract-plugin
module.exports = {"button":"FooterButton_button__3p1NK"};